/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PagamentoDTO
 */
export interface PagamentoDTO {
    /**
     * 
     * @type {number}
     * @memberof PagamentoDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PagamentoDTO
     */
    idCiclo?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagamentoDTO
     */
    acconto?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PagamentoDTO
     */
    data?: Date;
    /**
     * 
     * @type {number}
     * @memberof PagamentoDTO
     */
    importo?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PagamentoDTO
     */
    autorizzato?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof PagamentoDTO
     */
    dataAutorizzazione?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PagamentoDTO
     */
    idArxivar?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PagamentoDTO
     */
    note?: string | null;
}

/**
 * Check if a given object implements the PagamentoDTO interface.
 */
export function instanceOfPagamentoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PagamentoDTOFromJSON(json: any): PagamentoDTO {
    return PagamentoDTOFromJSONTyped(json, false);
}

export function PagamentoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagamentoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idCiclo': !exists(json, 'idCiclo') ? undefined : json['idCiclo'],
        'acconto': !exists(json, 'acconto') ? undefined : json['acconto'],
        'data': !exists(json, 'data') ? undefined : (new Date(json['data'])),
        'importo': !exists(json, 'importo') ? undefined : json['importo'],
        'autorizzato': !exists(json, 'autorizzato') ? undefined : json['autorizzato'],
        'dataAutorizzazione': !exists(json, 'dataAutorizzazione') ? undefined : (json['dataAutorizzazione'] === null ? null : new Date(json['dataAutorizzazione'])),
        'idArxivar': !exists(json, 'idArxivar') ? undefined : json['idArxivar'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function PagamentoDTOToJSON(value?: PagamentoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idCiclo': value.idCiclo,
        'acconto': value.acconto,
        'data': value.data === undefined ? undefined : (value.data.toISOString()),
        'importo': value.importo,
        'autorizzato': value.autorizzato,
        'dataAutorizzazione': value.dataAutorizzazione === undefined ? undefined : (value.dataAutorizzazione === null ? null : value.dataAutorizzazione.toISOString()),
        'idArxivar': value.idArxivar,
        'note': value.note,
    };
}

